import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "label", "labelClassName", "hideLabel", "listClassName", "inline", "field", "setFilter", "filters", "options"];
import React from 'react';
import classNames from 'classnames';
import { getFilterValueDisplay } from '@elastic/react-search-ui-views/lib/view-helpers';
import { withSearch } from '@elastic/react-search-ui';
import deepEqual from 'deep-equal';
import { findFacetValueInFilters } from '../helpers';
import { Button } from 'reactstrap';
var blockClass = 'search-filter';

var SingleLinksFacet = function SingleLinksFacet(_ref) {
  var className = _ref.className,
      label = _ref.label,
      labelClassName = _ref.labelClassName,
      hideLabel = _ref.hideLabel,
      listClassName = _ref.listClassName,
      inline = _ref.inline,
      field = _ref.field,
      setFilter = _ref.setFilter,
      filters = _ref.filters,
      options = _ref.options,
      attrs = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classes = classNames(blockClass, blockClass + "--single-link", className);
  var labelClasses = classNames(blockClass + "__title", labelClassName || 'h5 mb-0');
  var listClasses = classNames(blockClass + "__list", 'list-unstyled', inline ? blockClass + "__list--inline" : '', listClassName);
  var selectedValues = findFacetValueInFilters(field, filters, 'all') || [];
  var value = selectedValues[0];
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, attrs), !hideLabel && /*#__PURE__*/React.createElement("div", {
    className: labelClasses
  }, label), /*#__PURE__*/React.createElement("ul", {
    className: listClasses
  }, options.map(function (option, i) {
    var selected = !value && i === 0 || deepEqual(option.value, value);
    return /*#__PURE__*/React.createElement("li", {
      className: blockClass + "__item " + (selected ? blockClass + "__item--active" : ''),
      key: getFilterValueDisplay(option.value)
    }, /*#__PURE__*/React.createElement(Button, {
      className: blockClass + "__btn",
      color: "link",
      onClick: function onClick() {
        setFilter(field, option.value);
      }
    }, /*#__PURE__*/React.createElement("label", null, option.label)));
  })));
};

export var SingleLinksFacetComponent = SingleLinksFacet;
export default withSearch(function (_ref2) {
  var setFilter = _ref2.setFilter,
      filters = _ref2.filters;
  return {
    setFilter: setFilter,
    filters: filters
  };
})(SingleLinksFacet);